import {
  type ConfigureStoreOptions,
  configureStore,
  type TypedUseSelectorHook,
  useDispatch,
  useSelector
} from '@integrations/state'
import { middlewares, queryReducers } from 'mmfintech-backend-api'

const createStore = (options?: ConfigureStoreOptions['preloadedState'] | undefined) =>
  configureStore({
    reducer: queryReducers,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares.apiMiddleware),
    preloadedState: options
  })

export const store = createStore()

export type RootState = ReturnType<typeof store.getState>

type AppStore = ReturnType<typeof createStore>
export type AppDispatch = AppStore['dispatch']

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
